<template>
  <div class="left-box">
    <div class="left-title d-aligncnter">
      <img
        class="img-24"
        src="@/assets/img/academic/alarm.svg"
        style="width: 0.5rem; height: 0.5rem"
      />
      <div class="ml-4">各年级学业预警分布</div>
    </div>
    <div class="" style="margin-top: -20px">
      <div class="echarts">
        <div
          id="grade"
          :style="{
            width: '100%',
            height: '260px',
            margin: '0 auto',
          }"
        ></div>
      </div>
      <div style="margin-top: -20px">
        <div
          v-for="(item, index) in gradeWarningData"
          :key="'data_' + index"
          class="d-aligncnter myfont"
        >
          <div :style="{ background: myColor[index] }" class="small-box"></div>
          <div style="width: calc(60% - 86px)">
            {{ item.yearGrade }}级学业预警分布
          </div>
          <div style="width: 20%">{{ item.warningCount }}</div>
          <div style="width: 20%">{{ item.failRate | failPercent }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['gradeWarningData'],
  data() {
    return {
      option: {},
      myColor: [
        '#009AFE',
        '#007A4D',
        '#FFB612',
        '#F97423',
        '#DE3831',
        '#9419F8',
        '#4937B9',
      ],
      data: [
        { name: '本科一年级学业预警分布', value: 12, percent: '12%' },
        { name: '本科二年级学业预警分布', value: 12, percent: '12%' },
        { name: '本科三年级学业预警分布', value: 12, percent: '12%' },
        { name: '本科四年级学业预警分布', value: 12, percent: '12%' },
        { name: '本科五年级学业预警分布', value: 12, percent: '12%' },
      ],
    }
  },
  watch: {},
  created() {
    // var myChart1 = this.$echarts.init(document.getElementById('grade'))
    // myChart1.setOption(this.option)
  },
  mounted() {
    const that = this
    new Promise(function (resolve, reject) {
      for (let i = 0; i < that.gradeWarningData.length; i++) {
        that.data[i].name = that.gradeWarningData[i].yearGrade
        that.data[i].value = that.gradeWarningData[i].warningCount
      }
      resolve('成功') // 数据处理完成
      reject('成功') // 数据处理完成
    }).then(
      (res) => {
        that.initData()
        console.log(res)
        console.log('data：', this.data)
      }, // 成功
      (err) => {
        console.log(err)
      } // 失败
    )
  },
  filters: {
    failPercent: function (val) {
      return val.toFixed(2)
    },
  },
  computed: {},
  methods: {
    initData() {
      var myChart1 = this.$echarts.init(document.getElementById('grade'))
      this.option = {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: '5%',
          left: 'center',
          show: false,
        },
        color: this.myColor,
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: this.data,
          },
        ],
      }
      myChart1.setOption(this.option)
    },
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.left-box {
  width: calc(100% - 48px);
  margin-left: 24px;
  .left-title {
    font-size: 0.5rem;
    margin-bottom: 8px;
  }
  .left-table {
    width: calc(100% - 0px);
    font-size: 0.3rem;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
.small-box {
  width: 0.4rem;
  height: 0.2rem;
  border-radius: 90px;
  margin: 0 35px;
}
.myfont {
  font-size: 0.4rem;
  justify-content: space-evenly;
  margin-top: 8px;
  div {
    text-align: center;
  }
}
</style>
